import { NavLink } from "react-router-dom";
import { HeartHandshake, Compass, BookOpen, Sparkles, User } from "lucide-react";

const ITEMS = [
  { to: "/app/home", label: "Home", icon: HeartHandshake, id: "home" },
  { to: "/app/percorso", label: "Percorso", icon: Compass, id: "percorso" },
  { to: "/app/diario", label: "Diario", icon: BookOpen, id: "diario" },
  { to: "/app/academy", label: "Academy", icon: Sparkles, id: "academy" },
  { to: "/app/profilo", label: "Profilo", icon: User, id: "profilo" },
];

export function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      className="fixed bottom-0 left-0 right-0 z-50 bg-[#2A0A1B]/95 backdrop-blur-lg border-t border-[#6B2247] shadow-[0_-4px_20px_rgba(74,18,48,0.06)]"
    >
      <div className="max-w-md md:max-w-4xl mx-auto flex items-stretch justify-around px-2 py-2">
        {ITEMS.map(({ to, label, icon: Icon, id }) => (
          <NavLink
            key={id}
            to={to}
            data-testid={`tab-${id}`}
            className="flex flex-col items-center gap-1 py-1 px-2 min-w-[56px]"
          >
            {({ isActive }) => (
              <>
                <span
                  className="flex items-center justify-center w-11 h-9 rounded-full transition-all"
                  style={{
                    background: isActive ? "linear-gradient(135deg,#E32C8C,#8E1A52)" : "transparent",
                  }}
                >
                  <Icon
                    className="w-5 h-5 transition-colors"
                    style={{ color: isActive ? "#fff" : "#EAC6D9" }}
                  />
                </span>
                <span
                  className="text-[11px] font-medium"
                  style={{ color: isActive ? "#E32C8C" : "#EAC6D9" }}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
